import React, { useState } from 'react';
import ElEmbudo from '../ElEmbudo/ElEmbudo';
import PegaMas from '../PegaMas/PegaMas';

const Home: React.FC = () => {
  const [currentGame, setCurrentGame] = useState<number>(0);

  const handleFirstGameEnd = () => {
    setCurrentGame(0); // Cambiando a 0 temporalmente para dejar en loop a Pegamas
  };

  const handleSecondGameEnd = () => {
    setCurrentGame(0);
  };

  return (
    <div className="carousel-container">
      {currentGame === 0 ? (
        <PegaMas onGameEnd={handleFirstGameEnd} />
      ) : (
        <ElEmbudo onGameEnd={handleSecondGameEnd} />
      )}
    </div>
  );
};

export default Home;
